// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r2nTX","content":"styles_content__4JJ2f"};